import React, { useState, useMemo } from "react";
import { useApiDocsContext } from "../startup/ApiDocsApp";
import { generateCodeExamples } from "../utils/codeGenerator";
import CodeBlock from "./CodeBlock";

const TABS = [
  { key: "shell", label: "Shell", language: "bash" },
  { key: "nodejs", label: "Node.js", language: "javascript" },
  { key: "ruby", label: "Ruby", language: "ruby" },
  { key: "php", label: "PHP", language: "php" },
  { key: "python", label: "Python", language: "python" },
];

const CodeExampleTabs = ({ endpoint }) => {
  const { apiDocs } = useApiDocsContext();
  const [activeTab, setActiveTab] = useState("shell");

  const examples = useMemo(() => generateCodeExamples(endpoint, apiDocs.base_url), [endpoint, apiDocs.base_url]);

  const activeTabConfig = TABS.find((t) => t.key === activeTab);

  return (
    <div className="api-docs-code-examples">
      <h3>Request Example</h3>
      <div className="api-docs-code-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`api-docs-code-tab ${
              activeTab === tab.key ? "api-docs-code-tab--active" : ""
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <CodeBlock
        code={examples[activeTab]}
        language={activeTabConfig.language}
      />
    </div>
  );
};

export default CodeExampleTabs;
